export async function captureVideoFrameAsFile(
  video: HTMLVideoElement,
  filename = 'barcode-scan.jpg',
): Promise<File | null> {
  if (video.videoWidth === 0 || video.videoHeight === 0) {
    return null;
  }

  const canvas = document.createElement('canvas');
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;

  const context = canvas.getContext('2d');
  if (!context) {
    return null;
  }

  context.drawImage(video, 0, 0);

  const blob = await new Promise<Blob | null>((resolve) => {
    canvas.toBlob((value) => resolve(value), 'image/jpeg', 0.85);
  });

  if (!blob) {
    return null;
  }

  return new File([blob], filename, { type: 'image/jpeg' });
}
